export default function handlerCurrentKey(arr, options) {
  const { type, param, target } = options;

  /* INDIVIDUAL */
  if (type === 'individual' && arr.length !== 0) {
    const item = arr.find(({ id_candidato }) => id_candidato === param); // eslint-disable-line
    if (item) {
      const replace = item[target].replace(/%/g, '').replace(/,/, '.');
      return parseFloat(replace);
    }
    return null;
  }

  if (type === 'individual' && arr.length === 0) {
    return null;
  }

  /* VENCEDORES */
  if (arr.constructor === Array && arr.length !== 0) {
    return arr[0][target];
  }

  if (arr.constructor === Array && arr.length === 0) {
    return null;
  }

  return arr;
}

// export default (options = {}) => {
//   const { getState } = store;
//   const { initial } = getState();
//   const { listMerge, elements } = initial;
//   const { param } = initial;
//   const { currentKey, currentScale } = param;
//   const { context, props, path } = elements;
//   context.clearRect(0, 0, props.width, props.height);
//   listMerge.forEach((item) => {
//     if (item.dadosMunicipio) {
//       const value = handlerCurrentKey(item.dadosMunicipio[currentKey.key], currentKey);
//       if (value && value !== 'BRANCO' && value !== 'NULO') {
//         const color = currentScale(value);
//         // console.log('@@@ color', color);
//         // console.log('@@@ value', value);
//         // console.log('');
//         context.fillStyle = `${color}`;
//         context.strokeStyle = options.strokeStyle || color;
//         context.lineWidth = options.lineWidth || 0;
//         context.beginPath();
//         path(item);
//         context.stroke();
//         context.fill();
//         // context.closePath();
//       }
//     }
//   });
// };



// WEBPACK FOOTER //
// ./src/components/mapa/draw.js